// @file: src/components/unform/input-currency-label/index.js
import React, { useRef, useEffect, useState } from 'react';

import { useField } from '@unform/core';
import PropTypes from 'prop-types';

import { Container } from '../styles';

// Função para formatar valor como moeda brasileira
const formatCurrency = (value) => {
  if (!value) return '';

  // Remove tudo que não é dígito
  const numericValue = value.replace(/\D/g, '');

  // Converte para centavos
  const cents = parseInt(numericValue, 10);

  if (Number.isNaN(cents)) return '';

  // Converte centavos para reais
  const reais = cents / 100;

  // Formata como moeda brasileira
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(reais);
};

export default function InputCurrencyLabel({ name, label, ...rest }) {
  const inputRef = useRef(null);

  const { fieldName, defaultValue, registerField, error } = useField(name);

  const [inputValue, setInputValue] = useState(
    defaultValue ? formatCurrency(defaultValue.toString()) : ''
  );

  const handleChange = (e) => {
    const formattedValue = formatCurrency(e.target.value);
    setInputValue(formattedValue);
  };

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.value = inputValue;
    }
  }, [inputValue]);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
      setValue: (_, value) => {
        setInputValue(value);
      },
      clearValue: () => {
        setInputValue('');
      },
    });
  }, [fieldName, registerField]);

  return (
    <Container>
      <label htmlFor={fieldName}>{label}</label>

      <input
        id={fieldName}
        ref={inputRef}
        type="text"
        value={inputValue}
        onChange={handleChange}
        className={error ? 'input-error' : ''}
        placeholder="R$ 0,00"
        {...rest}
      />

      {error && <span className="error text-left ml-1">* {error}</span>}
    </Container>
  );
}

InputCurrencyLabel.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};
